import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const MessagesDetail = (props: SvgIconT.Props) => (
  <SvgIcon width={12} height={13} {...props} viewBox="0 0 12 13">
    <g transform="translate(-1843.000000, -147.000000)" fillRule="nonzero">
      <path d="M1853,147.5 C1854.10457,147.5 1855,148.395431 1855,149.5 L1855,157.5 C1855,158.604569 1854.10457,159.5 1853,159.5 L1845,159.5 C1843.89543,159.5 1843,158.604569 1843,157.5 L1843,149.5 C1843,148.395431 1843.89543,147.5 1845,147.5 L1853,147.5 Z M1854,152.348 L1848.79909,154.919916 L1844,152.595 L1844,157.5 C1844,158.012836 1844.38604,158.435507 1844.88338,158.493272 L1845,158.5 L1853,158.5 C1853.51284,158.5 1853.93551,158.11396 1853.99327,157.616621 L1854,157.5 L1854,152.348 Z M1853,148.5 L1845,148.5 C1844.48716,148.5 1844.06449,148.88604 1844.00673,149.383379 L1844,149.5 L1844,151.484 L1848.794,153.807 L1854,151.233 L1854,149.5 C1854,148.987164 1853.61396,148.564493 1853.11662,148.506728 L1853,148.5 Z"></path>
    </g>
  </SvgIcon>
);

export default MessagesDetail;
